<template>
  <div class="login-component">
    <WovenBrand
      title="Quick |digital payments| for the digital business."
      description="Woven provides a new type of payment account. Built for businesses that need a faster, easier and more reliable way to move money."
      no-step
    />
    <div class="login-component__login">
      <Logo classes="mobile-logo" />
      <Help />
      <div class="form" v-if="step === 'login' && !loading">
        <FormHeader
          title="Login"
          description="Welcome! Kindly login to continue moving your money through a fast, easy and reliable means. "
        />
        <form v-on:submit.prevent="checkUser2FAStatus" class="input-group" action="">
          <InputV2
            placeholder="Email Address"
            type="email"
            :required="true"
            v-model="email"
          />
          <InputV2
            placeholder="Password"
            type="password"
            :required="true"
            v-model="password"
          />
          <div class="flex-end">
            <router-link to="/password-reset" class="reset-password"
              >Reset Password?</router-link
            >
          </div>
          <Button
            buttonName="Continue"
            classes="woven-color"
            buttonType="submit"
            :disabled="isFormValid ? false : true"
            :onClick="() => {}"
          >
          </Button>
          <div class="register">
            Don’t have an account?
            <router-link to="/register">Create an account</router-link>
          </div>
        </form>
      </div>
      <div class="form" v-if="step === 'totp' && !loading">
          <FormHeader
            title="Two-Factor Authentication"
            description="Welcome! Please enter the code from your Google Authenticator app to securely access your account."
          />
          <form @submit.prevent="login" class="input-group" action="">
            <div class="pin_inputs">
              <input
              ref="pinOne"
              type="password"
              v-model="pinOne"
              @input="handleInput($event, 'pinOne', 'pinTwo')"
              @keydown="handleKeydown($event, 'pinOne')"
              maxlength="1"
              class="pin-input"
            />
            <input
              ref="pinTwo"
              type="password"
              v-model="pinTwo"
              @input="handleInput($event, 'pinTwo', 'pinThree')"
              @keydown="handleKeydown($event, 'pinTwo', 'pinOne')"
              maxlength="1"
              class="pin-input"
            />
            <input
              ref="pinThree"
              type="password"
              v-model="pinThree"
              @input="handleInput($event, 'pinThree', 'pinFour')"
              @keydown="handleKeydown($event, 'pinThree', 'pinTwo')"
              maxlength="1"
              class="pin-input"
            />
            <input
              ref="pinFour"
              type="password"
              v-model="pinFour"
              @input="handleInput($event, 'pinFour', 'pinFive')"
              @keydown="handleKeydown($event, 'pinFour', 'pinThree')"
              maxlength="1"
              class="pin-input"
            />
            <input
              ref="pinFive"
              type="password"
              v-model="pinFive"
              @input="handleInput($event, 'pinFive', 'pinSix')"
              @keydown="handleKeydown($event, 'pinFive', 'pinFour')"
              maxlength="1"
              class="pin-input"
            />
            <input
              ref="pinSix"
              type="password"
              v-model="pinSix"
              @input="handleInput($event, 'pinSix', null)"
              @keydown="handleKeydown($event, 'pinSix', 'pinFive')"
              maxlength="1"
              class="pin-input"
            />
            </div>
            <Button
              button-name="Login"
              classes="woven-color"
              button-type="submit"
              :disabled="isFormValid ? false : true"
              :on-click="() => {}"
            />
          </form>
      </div>
      <div class="form" v-if="step === 'totp-signup' && otpsignupData && !loading">
        <FormHeader
          title="Two-Factor Authentication"
          :description="otpsignupData.message"
        />
        <form @submit.prevent="verify2FA" class="input-group" action="">
          <div class="" style="margin-bottom: 20px;">
            <img :src="otpsignupData.qr_code" alt="" style="height: 212px; width: 212px;">
          </div>
          <div class="pin_inputs">
            <input
            ref="pinOne"
            type="password"
            v-model="pinOne"
            @input="handleInput($event, 'pinOne', 'pinTwo')"
            @keydown="handleKeydown($event, 'pinOne')"
            maxlength="1"
            class="pin-input"
          />
          <input
            ref="pinTwo"
            type="password"
            v-model="pinTwo"
            @input="handleInput($event, 'pinTwo', 'pinThree')"
            @keydown="handleKeydown($event, 'pinTwo', 'pinOne')"
            maxlength="1"
            class="pin-input"
          />
          <input
            ref="pinThree"
            type="password"
            v-model="pinThree"
            @input="handleInput($event, 'pinThree', 'pinFour')"
            @keydown="handleKeydown($event, 'pinThree', 'pinTwo')"
            maxlength="1"
            class="pin-input"
          />
          <input
            ref="pinFour"
            type="password"
            v-model="pinFour"
            @input="handleInput($event, 'pinFour', 'pinFive')"
            @keydown="handleKeydown($event, 'pinFour', 'pinThree')"
            maxlength="1"
            class="pin-input"
          />
          <input
            ref="pinFive"
            type="password"
            v-model="pinFive"
            @input="handleInput($event, 'pinFive', 'pinSix')"
            @keydown="handleKeydown($event, 'pinFive', 'pinFour')"
            maxlength="1"
            class="pin-input"
          />
          <input
            ref="pinSix"
            type="password"
            v-model="pinSix"
            @input="handleInput($event, 'pinSix', null)"
            @keydown="handleKeydown($event, 'pinSix', 'pinFive')"
            maxlength="1"
            class="pin-input"
          />
          </div>
          <Button
            button-name="Submit"
            classes="woven-color"
            button-type="submit"
            :disabled="disabled"
            :on-click="() => {}"
          />
        </form>
      </div>
      <div class="form" v-if="loading"
        style="
          display: flex;
          flex-direction: column;
          gap: 20px;
          justify-content: center;
          align-items: center;
          min-height: 300px;
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style="height: 40px; width: 40px"
          class="rolling-icon"
        >
          <path
            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
            style="fill: red"
          />
        </svg>
      </div>
      <BackgroundImage classes="mobile-background-image" />
      <WovenStrip :loading="disabled" />
    </div>
  </div>
</template> 

<script>
import WovenBrand from "@/components/wovenbrand.vue";
import FormHeader from "@/components/formheader.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import WovenStrip from "@/components/wovenstrip.vue";
import Help from "@/components/help.vue";
import Logo from "@/components/logo";
import BackgroundImage from "@/components/backgroundlogo";
export default {
  name: "Login",
  metaInfo: {
    title: "Login",
  },
  components: {
    WovenBrand,
    FormHeader,
    InputV2,
    Button,
    WovenStrip,
    Help,
    Logo,
    BackgroundImage
  },
  data() {
    return {
      email: "",
      password: "",
      disabled: false,
      error: false,
      step: "login",
      otpsignupData: null,
      loading: false,
      pinOne: "",
      pinTwo: "",
      pinThree: "",
      pinFour: "",
      pinFive: "",
      pinSix: "",
    };
  },
  watch: {
    step: function () {
      this.validate();
    },
    email: function () {
      this.validate();
    },
    password: function () {
      this.validate();
    },
    pinOne: function () {
      this.validate();
    },
    pinTwo: function () {
      this.validate();
    },
    pinThree: function () {
      this.validate();
    },
    pinFour: function () {
      this.validate();
    },
    pinFive: function () {
      this.validate();
    },
    pinSix: function () {
      this.validate();
    },
  },
  computed: {
    isFormValid() {
      return (
        this.email !== "" &&
        this.password !== "" &&
        !this.loading &&
        (this.step === "login" || (this.pinOne && this.pinTwo && this.pinThree && this.pinFour && this.pinFive && this.pinSix))
      );
    },
  },
  methods: {
    validate() {
      const isStepValid = this.step === "login" ? true : this.pinOne && this.pinTwo && this.pinThree && this.pinFour && this.pinFive && this.pinSix;
      const isValid = this.email !== "" && this.password !== "" && isStepValid;
      if (!isValid) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    async checkUser2FAStatus() {
      try {
        this.loading = true;
        const response = await this.$http.get(`totp/check?email=${this.email.trim()}`);
        const data = response.body.data;
        this.loading = false;
        if(data.has_totp){
          this.step = "totp";
        }else{
          this.step = "totp-signup";
          this.disabled = true;
          this.signup2fa();
        }
      } catch (error) {
          this.loading = false;
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
      }
    },
    async verify2FA() {
      try {
        this.loading = true;
        const response = await this.$http.post(`totp/admin/verify`, {
          "totp_code": this.pinOne + this.pinTwo + this.pinThree + this.pinFour + this.pinFive + this.pinSix,
          "action": "setup",
          "requestId": "optional-request-id"
        });
        this.loading = false;
        if(response.body.data.status ) {
          this.downloadObjectAsTxt(this.otpsignupData);
        }
      } catch (error) {
        this.loading = false;
        this.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.body.message,
        });
      }
    },
    async signup2fa() {
      this.validate();
      this.disabled = true;
      this.loading = true;
      if (this.email !== "" && this.password !== "") {
        let requestObject = {
          email: this.email.trim(),
          password: this.password.trim(),
        };
        this.$store
          .dispatch("login", requestObject)
          .then(async () => {
            const signup2fares = await this.$http.post(`totp/admin/setup`, {
              "requestId": "optional-request-id"
            });
            const resdata = signup2fares.body.data;
            this.disabled = false;
            this.otpsignupData = resdata;
            this.loading = false;
          })
          .catch((error) => {
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
            this.error = true;
            this.disabled = false;
            this.loading = false;
          this.step = "login";
          });
      } else {
        this.validate();
      }
    },
    login() {
      this.loading = true;
      this.disabled = true;
      if (this.email !== "" && this.password !== "") {
        let requestObject = {
          email: this.email.trim(),
          password: this.password.trim(),
          totp_code: this.pinOne + this.pinTwo + this.pinThree + this.pinFour + this.pinFive + this.pinSix,
        };
        this.$store
          .dispatch("login", requestObject)
          .then((response) => {
            this.loading = false;
            this.$router.push({ name: "overview" });
            this.disabled = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log("ben3");
            if (error.response && error.response.status === 401) {
    this.$store.dispatch("logout"); // Clear stored token
    this.$router.push({ name: "login" }); // Redirect to login page
    this.$notify({
      group: "notifications-default",
      type: "error text-white",
      title: "Session Expired",
      text: "Your session has expired. Please log in again.",
    });
  } else {
    // Handle other errors
    this.$notify({
      group: "notifications-default",
      type: "error text-white",
      title: "Error",
      text: error.body.message || "An unexpected error occurred.",
    });
  }
            this.error = true;
            this.disabled = false;
          });
      } else {
        if (this.email.value == "") {
          console.log("ben4");
          this.email.empty = true;
        }
        if (this.password.value == "") {
          console.log("ben5");
          this.password.empty = true;
        }
      }
    },
    downloadObjectAsTxt(data, fileName = 'backupcodes.txt') {
      let content = `Manual Entry Key:\n${data.manual_entry_key}\n\nBackup Codes:\n`;
      content += data.backup_codes.join("\n");
      const blob = new Blob([content], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
      this.$router.push({ name: "overview" });
    },
    handleInput(event, currentPin, nextPin) {
      const value = event.target.value;
      if (!/^\d*$/.test(value)) {
        event.target.value = this[currentPin];
        return;
      }
      this[currentPin] = value;
      if (value && nextPin) {
        this.$nextTick(() => {
          this.$refs[nextPin].focus();
        });
      }
    },
    handleKeydown(event, currentPin, previousPin) {
      if (event.key === "Backspace" && !this[currentPin] && previousPin) {
        this.$nextTick(() => {
          this.$refs[previousPin].focus();
        });
      }
    },
  },
};
</script>

<style lang="scss">
.pin_inputs{
  display: flex;
  justify-content: center;
  align-items: center;
}
  .pin_inputs input {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    margin: 0 5px;
    border: 1px solid #e00b5b;
    outline: none;
    border-radius: 8px;
  }
.rolling-icon {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.login-component {
  background: #fff;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  &__login {
    flex: 0.8;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100vh;
    &__help {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      color: #616e7c;
      position: absolute;
      top: 64px;
      right: 64px;
      span {
        color: #000;
        text-decoration: underline;
      }
    }
    .form {
      max-width: 465px;
      button {
        width: 100%;
        height: 48px;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .register {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #616e7c;
        a {
          color: #000;
          text-decoration: underline;
        }
      }
      .terms-condition {
        display: flex;
        align-items: center;
        svg {
          margin-right: 10px;
        }
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #616e7c;
        }
      }
    }
    .input-group {
      padding-top: 30px;
    }
  }
  .input-v2 {
    input {
      margin-bottom: 20px;
    }
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
  .reset-password {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    color: #e00b5b;
    cursor: pointer;
  }
  .btn {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .woven-brand {
    flex: 0.2;
    height: 100vh;
    padding: 64px;
    max-width: 430px;
    min-width: 350px;
    &__description {
      padding-top: 32px;
    }
  }
  .mobile-logo {
    display: none;
  }
  .mobile-background-image {
    display: none;
  }
  @media screen and (max-width: 880px) {
    .mobile-background-image {
      display: block;
    }
    .woven-brand {
      display: none
    }
    .mobile-logo {
      display: block;
      position: absolute;
      top: 40px;
      left: 5%;
    }
    .help-component {
      top: 50px;
      right: 5%;
    }
    &__login {
      flex: 1;
      padding: 5%;
      .form {
        height: 60vh;
      }
    }
  }
}
</style>